import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"mx-auto",attrs:{"width":"100%","color":"transparent"}},[_c(VCardText,[_c('introduction')],1),_c(VCardText,[_c('about')],1),_c(VCardText,[_c('skills')],1),_c(VCardText,[_c('portfolio')],1),_c(VCardText,[_c('contact')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }